import React from 'react';
import { ErrorBoundary, SessionTimeoutModal } from '@vz/react-util';
import Router from './router';
import { GlobalStyle } from './App.styles';

const App = () => {
  
  return (
    <ErrorBoundary>
      <GlobalStyle />
      <Router/>
      <SessionTimeoutModal />
    </ErrorBoundary>
  );
};

export default App;
